function init(){
    // The script now loads on every page.landing* template, not just page.landing.
    // Templates that don't render the bundle builder (e.g. page.landing-venetian,
    // which is main-page only) have no JSON blob and no [data-main-atc] button, so
    // bail out before binding anything rather than throwing on a null querySelector.
    const bundleJSONEl = document.querySelector('[data-bundle-pairs-products-json]');
    const mainATC = document.querySelector('[data-main-atc] button');
    if (bundleJSONEl == null || mainATC == null) return;

    try {
        window.bundlePairJSON = JSON.parse(bundleJSONEl.innerHTML);
    } catch (err) {
        console.error('[bundle-pairs] could not parse [data-bundle-pairs-products-json]:', err);
        return;
    }
    window.bundleItems = [];
    window.bundlePrice = 0;
    window.bundleCoPrice = 0;
    const productSels = document.querySelectorAll('[data-bundle-product-selector]');
    const bundleLevels = document.querySelectorAll('[data-bundle-levels]');
    bundleLevels.forEach((bnd) => {
        bnd.querySelector('input').addEventListener('change', (e) => {
            document.querySelectorAll('[data-bundle-levels]').forEach((ele) => ele.classList.remove('selected'));
            if(e.target.checked){
                e.target.closest('[data-bundle-levels]').classList.add('selected');
            } else{
                e.target.closest('[data-bundle-levels]').classList.remove('selected');
            }
            
        })
    })
    productSels.forEach((ele)=>ele.addEventListener('change', (e) =>{
        loadProductSwatches(e);
        prepareATC(e);
        checkATC();
    }));
    document.querySelector('body').addEventListener('change', (e) =>{
        if(e.target.matches('[data-collection-product-swatches] input[data-swatch-listing]')){
            loadProductVariants(e);
            prepareATC(e);
            checkATC();
        }
        if(e.target.matches('input[data-size-listing]')){
            changeVariantSel(e);
            prepareATC(e);
            checkATC();
        }
    })
    
    mainATC.addEventListener('click', (e) => {
        e.preventDefault();
        addBundlesToCart(e);
    })
    document.querySelector('body').addEventListener('click', (e) =>{
        if(e.target.matches('[data-thumb-img]')){
            const ele = e.target.closest('product-thumbs');
            const mediaId = e.target.closest('a').dataset.mediaId;
            e.target.closest('product-images').dataset.activeMedia = mediaId;
            ele.setActiveThumb();  
            const activeSlide = document.querySelector('.product__slide.media--active');
            activeSlide.classList.remove('media--active');
            activeSlide.classList.add('media--hidden');
            document.querySelector('.product__slide[data-media-id="'+mediaId+'"]').classList.add('media--active');
            document.querySelector('.product__slide[data-media-id="'+mediaId+'"]').classList.remove('media--hidden');
        }
        if(e.target.matches('[data-rem-prd]') || e.target.closest('[data-rem-prd]') != null){
            removeProductfrombundle(e);
        }
    })
}
function loadProductSwatches(e){
    // console.log('bundlePairJSON',window.bundlePairJSON,e.currentTarget);
    const bundleId = e.currentTarget.dataset.bundleId;
    const selectedBundle = window.bundlePairJSON.bundles.filter((item) => item.bundleId == bundleId);
    // console.log('selectedBundle',selectedBundle);
    const bundleIndex = selectedBundle[0].bundleIndex;
    const selectedCollection = selectedBundle[0].collections.filter((item) => item.collectionId == e.currentTarget.value);
    // console.log('selectedCollection',selectedCollection);
    const productSwatchesContainer = e.currentTarget.closest('.tab__content').querySelector('[data-collection-product-swatches]');
    productSwatchesContainer.innerHTML = '';
    selectedCollection[0].first_product.map((ele, i) => {
    productSwatchesContainer.innerHTML+= `<div class="bundle_groups">
                                            <span data-group-id="${ele.group_id}" data-sel-coll-name class="d-flex font-size-normal sel-val${/Final Sale/.test(ele.title) ? ' last-chance-sg' : ''}">${ele.title}${/Final Sale/.test(ele.title) ? '' : ':'} <span></span></span>
                                            <div class="product-swtaches product-variation__list input__select-wrapper">
                                                ${ele.products.map((prd) => {
                                                  return  `
                                                  <radio-swatch
                                                        class="swatches swatch__button swatch__button--square swatch__button swatch-${ prd.color_handle }"
                                                        data-tooltip="${ prd.color_value }"
                                                            style="--swatch: var(--${ prd.color_handle });"
                                                    >
                                                  <input data-color-value="${prd.color_value}"  value="${selectedCollection[0].collectionId}" data-swatch-listing data-bundle-id="${selectedBundle[0].bundleId}" data-product-id="${prd.id}" type="radio" name="swatch-sel-${bundleIndex}" id="swatch-sel-${bundleIndex}-${prd.id}"">
                                                    <label for="swatch-sel-${bundleIndex}-${prd.id}" class="card-swatches__button card-swatches__button--large">
                                                        <div class="card-swatches__swatch card-swatches__swatch--large " style="${prd.color_code}">
                                                            <span class="sr-only">${prd.color_value}</span>
                                                        </div>
                                                    </label>
                                                    </radio-swatch>`
                                                }).join("")}
                                            </div>
                                        </div>`
    });

    resetAll(e,selectedBundle[0]);
    
}
function loadProductVariants(e){
    const id = e.target.dataset.productId;
    const bundleId = e.target.dataset.bundleId;
    const selectedBundle = window.bundlePairJSON.bundles.filter((item) => item.bundleId == bundleId);
    window.selectedBundle = selectedBundle[0];
    const bundleIndex = selectedBundle[0].bundleIndex;
    const selectedCollection = selectedBundle[0].collections.filter((item) => item.collectionId == e.target.value);
    const selCollName = e.target.closest('.bundle_groups').querySelector('[data-sel-coll-name]');

    document.querySelectorAll('[data-bundle-levels]').forEach((ele) => ele.classList.remove('selected'));
    e.target.closest('[data-bundle-products-section]').classList.add('selected');

    // console.log('selectedCollection',selectedCollection,e.target.value);
    
    document.querySelectorAll('[data-sel-coll-name]').forEach((ele) =>{
        if(ele.querySelector('[data-product-color]') != null) {
            ele.querySelector('[data-product-color]').remove();
        };
    })
    if(selCollName != null) {
        selCollName.querySelector('span').innerHTML =  `<span class="font-bold" data-product-color>${e.target.dataset.colorValue}</span>`;
    };
    // console.log('selectedBundle',selectedBundle,bundleId,selectedCollection,e.target.value,id);
    let selectedProduct;
    selectedCollection[0].first_product.every((grp) =>{
        selectedProduct =  grp.products.filter((prd) => prd.id == id);
        if(selectedProduct.length > 0) return false
        else return true
    })
    window.selectedProduct = selectedProduct[0];
    // console.log('selectedProduct',selectedProduct);
    const colorCode = e.target.closest('.tab__content').querySelector('[data-product-color]');
    const sizeSwatches = e.target.closest('.tab__content').querySelector('[data-collection-size-swatches]');
    const productGallery = document.querySelector('product-images .image-gallery-container');
    const productThumbs = document.querySelector('product-thumbs .product__thumbs__holder');
    const zoomEnabled = document.querySelector('.index-product[data-zoom-enabled]') != null;
   
    productGallery.innerHTML = '';
    productThumbs.innerHTML = '';
    // change slider
    selectedProduct[0].images.map((img,index) => {
        console.log('change images');
        productGallery.innerHTML+= `<div
                                    class="product__slide ${index == 0 ? 'media--active' : 'media--hidden'}"
                                    data-image-id="${ img.id }"
                                    data-media-id="template--23982969323820__main-${ img.id }"
                                    data-slide>
                                    ${ img.media_type == "image" ?
                                    `
                                    <div class="product__photo"
                                    tabindex="0"
                                    style="--aspect-ratio: ${img.preview_image.aspect_ratio}"
                                    ${ zoomEnabled == true ?
                                        `
                                        data-zoom-image
                                        data-image-src="${ img.src }"
                                        data-image-width="3000"
                                        data-image-height="3000"
                                        `
                                        : ``
                                    }
                                >
                                    <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill" style="--aspect-ratio: ${img.preview_image.aspect_ratio};">
                                        <img src="${img.media_type == "image" ? img.src : img.sources[0].url}" alt="${img.alt}" width="1600" height="2000" loading="eager">
                                    </figure>

                                    </div>

                                    ` :
                                    ` <deferred-media class="product__media deferred-media" style="padding-top: 125.0%;" loaded="true">
                                    <video playsinline="playsinline" controls="controls" class="media-video" autoplay="autoplay" preload="none" muted="muted" 
                                    aria-label="${img.alt}" poster="${img.preview_image.src}">
                                        <source src="${img.sources[0].url}" type="video/mp4">
                                        <img alt="${img.alt}" src="${img.preview_image.src}">
                                    </video>
                                </deferred-media>`
                                }
                                       
                                           
                                        
                                    </div>`;
        productThumbs.innerHTML+= `<div class="product__thumb ${index == 0 ? 'is-active' : ''}" data-thumb-item>
                                        <a href="javascript:void(0)" aria-current="${index == 0 ? 'true' : 'false'}"
                                        data-media-id="template--23982969323820__main-${ img.id }" data-thumb-link>
                                        <figure class="image-wrapper lazy-image lazy-image--backfill" style="--aspect-ratio: ${img.preview_image.aspect_ratio};">
                                            <img data-thumb-img src="${img.media_type == "image" ? img.src : img.preview_image.src}" alt="${img.alt}" width="150" height="190" loading="eager">
                                        </figure>
                                        </a>
                                    </div>`;
    })
    if(colorCode != null) colorCode.innerHTML = selectedProduct[0].color_value;
    sizeSwatches.innerHTML = '';
    // change size swatches
    selectedProduct[0].variants.map((variant,i) =>{
        var price = variant.price / 100;
        sizeSwatches.innerHTML+= `<span class="size_swatch font-semibold d-flex radio__button">
                                    <input data-var-title="${variant.options[1]}" data-size-listing type="radio" 
                                    ${!variant.available ? 'disabled': ''}
                                    data-product-id="${selectedProduct[0].id}"
                                    data-price="${Math.round(price)}" data-comp-price="${Math.round(variant.price / 100)}"
                                    name="bundle_variant_selectors_${bundleIndex}_${selectedProduct[0].id}" 
                                    value="${variant.id}" id="variant-sel-${bundleIndex}-${selectedProduct[0].id}-${i}">
                                    <label for="variant-sel-${bundleIndex}-${selectedProduct[0].id}-${i}">
                                    ${variant.options[1]}
                                    </label>
                                </span>`;
    });

    if(Object.keys(window.bundleItems).length)  window.bundleItems = window.bundleItems.filter((item,i) => i != selectedBundle[0].bundleIndex - 1);
}
function changeVariantSel(e){
    // console.log('vatitle',e.target.dataset);
    let selVal = e.target.dataset.varTitle;
    let selPrice = e.target.dataset.price;
    let selCoPrice = e.target.dataset.compPrice || 0;
    // console.log('selPrice',selPrice,'selCoPrice',selCoPrice);
    let swatchEle = e.target.closest('.tab__content').querySelector('input[data-swatch-listing]:checked');
    let nextEle = e.target.closest('[data-bundle-products-section]').nextElementSibling;
    // const stickyBundleImgs = document.querySelector('[data-bundle-items]');
    const id = e.target.dataset.productId;
    const bundleId = swatchEle.dataset.bundleId;
    const selectedBundle = window.bundlePairJSON.bundles.filter((item) => item.bundleId == bundleId);
    window.selectedBundle = selectedBundle[0];
    const selectedCollection = selectedBundle[0].collections.filter((item) => item.collectionId == swatchEle.value);
    let selectedProduct;
    selectedCollection[0].first_product.every((grp) =>{
        // console.log('grp',grp,id);
        selectedProduct =  grp.products.filter((prd) => prd.id == id);
        // console.log('selectedProduct.length',selectedProduct.length);
        if(selectedProduct.length > 0) return false
        else return true
    })
    window.selectedProduct = selectedProduct[0];
    let finalImgDiv = document.querySelector('[data-final-img][data-index="'+window.selectedBundle.bundleIndex+'"]');

    if(swatchEle != null && nextEle.hasAttribute('data-bundle-products-section')){
        nextEle.querySelector('input').checked = true;
        nextEle.classList.add('selected');
        e.target.closest('.tab').querySelector('input').checked = false;
        e.target.closest('[data-bundle-products-section]').classList.remove('selected');
    }
    
    // change final img details
    if(finalImgDiv != null){
        if(finalImgDiv.querySelector('img') != null){
            finalImgDiv.querySelector('img').remove();
            finalImgDiv.querySelector('[data-img-cont]').classList.remove('active-img');
            finalImgDiv.querySelector('[data-rem-prd]').classList.add('hidden');
        } 
        finalImgDiv.querySelector('[data-img-cont]').insertAdjacentHTML("beforeend",`<img class="object-fit-cover" alt="" src="${window.selectedProduct.image}">`);
        finalImgDiv.querySelector('[data-img-cont]').classList.add('active-img');
        finalImgDiv.querySelector('[data-rem-prd]').classList.remove('hidden');
        finalImgDiv.querySelector('[data-bundle-product-details]').innerHTML = `<p class="font-semibold">${window.selectedProduct.title}</p>
                                                                                <p class="font-medium">${selVal},${window.selectedProduct.color_value}</p>
                                                                                <p class="font-medium ${selCoPrice == selPrice ? 'hidden': ''}">${selCoPrice != 0 && selCoPrice != selPrice ?  '<s>$'+selCoPrice+'</s> ': ''} <span>$${selPrice}</span></p>`;
    }
}
function prepareATC(e){
    const varSwatches = document.querySelectorAll('[data-collection-size-swatches]');

    window.bundleItems = [];
    window.bundlePrice = 0;
    window.bundleCoPrice = 0;
    varSwatches.forEach((variant,i) => {
        // console.log('var id',variant.querySelector('input:checked'));
        if(variant.querySelector('input:checked') != null){
            let id = variant.querySelector('input:checked').value;
            if(document.querySelector('[data-no-bundle-discount]') == null){
                window.bundlePrice += parseFloat(variant.querySelector('input').dataset.price);
                // console.log('variant.dataset.compPrice',variant.querySelector('input').dataset.compPrice);
                window.bundleCoPrice += parseFloat(variant.querySelector('input').dataset.compPrice);
            }
            window.bundleItems.push({
                "id": id
            })
        }
    })
    
}
function checkATC(){
    const atcBtn = document.querySelector('.final_atc_step button');
    // const stickyATC = document.querySelector('[data-sticky-atc-bundle-products]');
    const atcPricediv = document.querySelectorAll('[data-price-details]');
    // if(Object.keys(window.bundleItems).length >= window.bundlePairJSON.bundles.length - 1){
    if(Object.keys(window.bundleItems).length >= 1){
        // Tier price comes from each bundle_pair metaobject's sale_info, emitted as
        // tierQty/tierPrice by snippets/landing-bundle_products-ht.liquid. This was
        // hardcoded to the Dali ladder (79/120/150), which was silently wrong on every
        // other landing page. (Aug 2026)
        const tierPrice = resolveBundleTierPrice(Object.keys(window.bundleItems).length);
        if (tierPrice != null) {
            window.bundlePrice = tierPrice;
        }
        atcBtn.disabled = false;
        atcBtn.querySelector('[data-atc-txt]').innerHTML = "Add to Cart"; 
        atcBtn.querySelector('[data-atc-price]').innerHTML = `- $${window.bundlePrice}  ${window.bundleCoPrice != 0 && window.bundleCoPrice - window.bundlePrice != 0 ? '<s> $'+window.bundleCoPrice+' </s>' : ''}`; 
        
        atcBtn.querySelector('[data-atc-price]').classList.remove('hidden');
        
        if(window.bundleCoPrice - window.bundlePrice != 0){
            atcPricediv.forEach((ele)=>{
                ele.querySelector('[data-atc-price]').innerHTML= `$${window.bundlePrice}`;
                ele.querySelector('[data-comp-price]').innerHTML= `$${window.bundleCoPrice}`;
                ele.querySelector('[data-savings]').innerHTML = `Save $${parseInt(window.bundleCoPrice - window.bundlePrice)}`;
                ele.querySelector('[data-savings]').closest('.product__sale').classList.remove('hidden');
                ele.classList.remove('hidden');
                ele.classList.add('d-flex');
            })
        }
       
    } else{
        atcBtn.disabled = "disabled";
        atcBtn.querySelector('[data-atc-txt]').innerHTML = "Add to cart";
        atcBtn.querySelector('[data-atc-price]').classList.add('hidden');
        // stickyATC.querySelector('[data-atc-txt]').innerHTML = "Add to cart";
        // stickyATC.querySelector('[data-atc-price]').classList.add('hidden');
        // stickyATC.dataset.atc = false;
        if(window.bundleCoPrice - window.bundlePrice != 0){
            atcPricediv.forEach((ele)=>{
                ele.classList.add('hidden');
                ele.classList.remove('d-flex');
            })
        }
    }
}
function addBundlesToCart(e){
    const btn = e.currentTarget;
    btn.classList.add('is-loading');

    window.bundleItems.forEach((item) => {
        item['quantity'] = 1
    })
    fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: window.bundleItems }) })
    .then((res) => res.json())
    .then((res) => {
        btn.classList.remove('is-loading');
        // Soludos: open/refresh the cart drawer - Rebuy used to pick this add up on its own
        if (window.SoludosCart) window.SoludosCart.refresh();
        // removeAllBundles();
    })
    .catch((e) => {
        console.error("Error:", e);
    });
}
function removeAllBundles(){
    const remBtn = document.querySelectorAll('[data-rem-prd]:not(.hidden)');
    remBtn.forEach((ele) => {
        const fakeEvent = { target: ele }; // simulate an event object
        removeProductfrombundle(fakeEvent);
    })


}
function removeProductfrombundle(e){
    const selInd = parseInt(e.target.getAttribute('data-index')) || parseInt(e.target.closest('[data-index]').getAttribute('data-index'));

    resetAll('remove',window.bundlePairJSON.bundles[selInd]);
    window.bundleItems[selInd] = null;
    prepareATC(e);
    checkATC();
}
function resetAll(e,bundle){
    if(e != 'remove'){}
    const sizeRadios = e != 'remove' ? e.currentTarget.closest('.tab__content').querySelectorAll('input[data-size-listing]'): 
                                        document.querySelector('[data-bundle-products-section="'+bundle.bundleIndex+'"]').querySelector('.tab__content').querySelectorAll('input[data-size-listing]');
    const swatchRadios = e != 'remove' ? e.currentTarget.closest('.tab__content').querySelectorAll('input[data-swatch-listing]') : 
                                        document.querySelector('[data-bundle-products-section="'+bundle.bundleIndex+'"]').querySelector('.tab__content').querySelectorAll('input[data-swatch-listing]');
    let finalImgDiv = document.querySelector('[data-final-img][data-index="'+bundle.bundleIndex+'"]');
    // const stickyBundleImgs = document.querySelector('[data-bundle-items]');
    swatchRadios.forEach((sw) =>{
        sw.checked = false;
        sw.dispatchEvent(new Event('change'));
    })
    sizeRadios.forEach((rad) => {
        rad.checked = false;
        rad.dispatchEvent(new Event('change'));
    })
    if(finalImgDiv != null){
        if(finalImgDiv.querySelector('img') != null){
            finalImgDiv.querySelector('img').remove();
            finalImgDiv.querySelector('[data-img-cont]').classList.remove('active-img');
            finalImgDiv.querySelector('[data-rem-prd]').classList.add('hidden');
        } 
        finalImgDiv.querySelector('[data-bundle-product-details]').innerHTML = 'Select an Item'
    }

}

/**
 * Resolve the bundle price for a number of selected pairs from the ladder in
 * window.bundlePairJSON (one tier per bundle_pair metaobject on the page).
 *
 *   exact qty match          -> that tier's price
 *   count above the top tier -> the top tier's price (matches the old `else`
 *                               branch: 4 pairs on a 3-tier page paid the 3-pair
 *                               price)
 *   count below the lowest tier, or no usable tiers on the page
 *                            -> null, which leaves the real summed variant total
 *                               in window.bundlePrice rather than inventing one
 */
function resolveBundleTierPrice(count){
    const bundles = (window.bundlePairJSON && window.bundlePairJSON.bundles) || [];
    const tiers = bundles
        .map((b) => ({ qty: parseInt(b.tierQty, 10), price: parseFloat(b.tierPrice) }))
        .filter((t) => t.qty > 0 && t.price > 0)
        .sort((a, b) => a.qty - b.qty);

    if (tiers.length === 0 || !(count > 0)) return null;

    const exact = tiers.find((t) => t.qty === count);
    if (exact) return exact.price;

    const below = tiers.filter((t) => t.qty < count).pop();
    return below ? below.price : null;
}

init();